import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=72776aec&scoped=true&"
var script = {}
import style0 from "./Contact.vue?vue&type=style&index=0&id=72776aec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72776aec",
  null
  
)

export default component.exports